"use strict";

function AntivirusTestBox($scope) {
    const ctrl = this;

    ctrl.$onInit = function () {
        $scope.sentinelOneScan = true;
        $scope.currentInput = null;
        $scope.scanResult = '';
        $scope.error = '';
    }

  $scope.onFileSelected = function(event) {
        if(event.target.files.length > 0) {
            $scope.currentInput = event.target.files[0];
        }
  }

  $scope.scanFile = function () {
          if ($scope.currentInput === null) {
              alert("File is missing");
              return;
          }
          const formData = new FormData();
          formData.append('file', $scope.currentInput);
          store.uploadFile({
              url: "/av/scan?sentinelOne=" + $scope.sentinelOneScan,
              method: "POST",
              file: formData,
              contentType: 'multipart/form-data',
              success: function(data) {
                  $scope.scanResult = JSON.stringify(data, undefined, 4);
                  $scope.error = '';
              },
              error: function error(_error) {
                  $scope.error = 'Failed to scan file';
              }
          });
  }
}